import { useState } from "react";
import { Link } from "react-router-dom";
import { X, PhoneCall, Check } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";

export function CallbackModal({ onClose, pet, estimate, source = "hero-callback" }) {
  const [phone, setPhone] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (phone.replace(/\D/g, "").length < 9) return toast.error("Inserisci un numero valido");
    setLoading(true);
    try {
      await api.post("/public/leads", { name: name || "Amico pet", phone, pet, estimate, consent_privacy: true, callback_requested: true, source });
      localStorage.setItem("pp_exit_captured_v2", "1");
      setDone(true);
    } catch (err) { toast.error(errorMessage(err)); } finally { setLoading(false); }
  };

  return (
    <div className="fixed inset-0 z-[100] grid place-items-center bg-black/50 p-4" onClick={onClose} data-testid="callback-overlay">
      <form onSubmit={submit} onClick={(e) => e.stopPropagation()} className="relative w-full max-w-md rounded-2xl bg-white p-6 shadow-2xl" data-testid="callback-modal">
        <button type="button" onClick={onClose} className="absolute right-3 top-3 grid h-8 w-8 place-items-center rounded-full hover:bg-muted" aria-label="Chiudi" data-testid="callback-close"><X size={16} /></button>
        {done ? (
          <div className="text-center py-4" data-testid="callback-success">
            <span className="mx-auto mb-3 grid h-12 w-12 place-items-center rounded-full bg-emerald-500 text-white"><Check /></span>
            <p className="font-display text-xl font-bold">Perfetto{name ? `, ${name.split(" ")[0]}` : ""}!</p>
            <p className="text-sm text-muted-foreground mt-2">Ti richiamiamo entro 48 ore lavorative dal numero di Polizzapet.it. Dieci minuti, zero gergo, nessun obbligo.</p>
            <button type="button" onClick={onClose} className="btn-primary mt-5 text-sm" data-testid="callback-done-close">Chiudi</button>
          </div>
        ) : (
          <>
            <span className="grid h-11 w-11 place-items-center rounded-xl bg-emerald-500/10 text-emerald-600"><PhoneCall size={22} /></span>
            <h3 className="font-display text-xl font-bold mt-3">Ti richiamiamo noi, gratis</h3>
            <p className="text-sm text-muted-foreground mt-1">Dieci minuti con una persona vera{pet?.breed ? ` per capire cosa conviene per il tuo ${pet.breed}` : ""}. Entro 48 ore, nessun obbligo.</p>
            <input type="tel" required autoFocus className="input mt-4 text-lg font-mono" placeholder="Il tuo numero (es. 333 1234567)" value={phone} onChange={(e) => setPhone(e.target.value)} data-testid="callback-phone" />
            <input className="input mt-2" placeholder="Come ti chiami? (opzionale)" value={name} onChange={(e) => setName(e.target.value)} data-testid="callback-name" />
            <button className="btn-primary w-full mt-4 !py-3" disabled={loading} data-testid="callback-submit">{loading ? "Un attimo…" : <><PhoneCall size={16} /> Richiamatemi gratis</>}</button>
            <p className="mt-3 text-[10px] text-muted-foreground">Inviando accetti la <Link to="/privacy" className="underline">Privacy Policy</Link>. Usiamo il numero solo per richiamarti.</p>
          </>
        )}
      </form>
    </div>
  );
}
